/* tslint:disable */
import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class StatusMessageService {

    private statusSource = new BehaviorSubject<string>('');
    private dotInterval: any;
    private hideTimeout: any = null; // Store timeout reference
    constructor() {
    }

    status$ = this.statusSource.asObservable();

    async updateStatus(message: string, animatedDots: boolean = false, autoHide: boolean = false, timeout: number = 2000) {
        console.log(`updateStatus called with message: "${message}", autoHide: ${autoHide}, timeout: ${timeout}`);

        // Add a small delay to allow UI updates
        await new Promise(resolve => setTimeout(resolve, 50));

        // Clear previous animation if any
        if (this.dotInterval) {
            console.log("Clearing previous dot animation");
            clearInterval(this.dotInterval);
            this.dotInterval = null;
        }

        if (animatedDots) {
            let dots = '';
            this.dotInterval = setInterval(() => {
                dots = dots.length < 3 ? dots + '.' : ''; // Cycle through `.`, `..`, `...`
                this.statusSource.next(`${message}${dots}`);
            }, 500);
        } else {
            this.statusSource.next(message);
        }

        // Handle auto-hide behavior
        if (autoHide) {
            console.log("Auto-hide enabled, setting timeout...");

            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                console.log("Cleared previous hide timeout");
            }

            this.hideTimeout = setTimeout(() => {
                console.log("Timeout reached, clearing message...");

                // Clear interval (dots) to ensure it doesn't interfere
                if (this.dotInterval) {
                    clearInterval(this.dotInterval);
                    this.dotInterval = null;
                }

                this.statusSource.next('');
                this.hideTimeout = null;
            }, timeout);
        }
    }

}
